export default "__VITE_ASSET__33314995__"